/*
 * Need to define this as a separate function so it can be mocked, since it is challenging to test window.location.assign with jsdom.
 * */
export const navigateToUrl = (url: string) => {
    window.location.assign(url);
};
